<template>
  <div class="p-8">
    <header class="flex justify-center mb-8">
      <img alt="Vue logo" src="../assets/logo.png">
    </header>
    <div class="container w-2/3">
      <h1 class="text-center mb-4">Site în construcție...</h1>
      <p class="text-center mb-4">Dar ne poți contacta la unul dintre cabinetele noastre</p>
      <div class="-mx-4 flex flex-wrap">
        <item v-for="item in items" :key="item.order" :item="item"></item>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Item from "../components/Item";
let items = {};
items = {
  "1": {
    order: 1,
    city: "Bucureşti",
    name: "Sediul Central",
    image: "bucuresti-central.jpg",
    address: "Str. Gheorghe Ţiţeica  nr. 121C, Etaj 4, Sector 2",
    phone: "021 311 96 23 / 0758 990 023 / 0800 800 654 TELVERDE",
    email: "customerservice@starkey.ro",
    schedule: "Luni – Vineri, orele 9-17",
    maplink: null
  },
  "2": {
    order: 2,
    city: "Bucureşti",
    name: "Cabinet Moșilor",
    image: "bucuresti-mosilor.jpg",
    address: "Calea Moşilor nr. 274, Bloc 18, Parter, Sector 4 ",
    phone: "021 211 01 35 / 0748 196 246",
    email: null,
    schedule: "Luni – Vineri, orele 9-17",
    maplink: null
  },
  "3": {
    order: 3,
    city: "Bucureşti",
    name: "Cabinet Unirii",
    image: "bucuresti-unirii.jpg",
    address: "Bld. Unirii nr. 17, bloc 4A, Parter, Sector 4 ",
    phone: "021 335 05 25  / 0748 196 245",
    email: null,
    schedule: "Luni – Vineri, orele 9-17",
    maplink: null
  },
  "4": {
    order: 4,
    city: "Brasov",
    name: null,
    image: "brasov.jpg",
    address: "Str. Avram Iancu nr.46",
    phone: "0268 475 089 / 0748 035 420",
    email: null,
    schedule: "Luni – Vineri, orele 9-17",
    maplink: null
  },
  "5": {
    order: 5,
    city: "Cluj Napoca",
    name: null,
    image: "cluj.jpg",
    address: "Calea Moţilor nr.20-22",
    phone: "0264 598 788 / 0730 115 844",
    email: null,
    schedule: "Luni – Vineri, orele 9-17",
    maplink: null
  },
  "6": {
    order: 6,
    city: "Pitesti",
    name: null,
    image: "pitesti.jpg",
    address: "Aleea Spitalului nr.24",
    phone: "0348 439 936 / 0748 035 428",
    email: null,
    schedule: "Luni – Vineri, orele 9-17",
    maplink: null
  }
};

export default {
  name: "home",
  data: function() {
    return {
      items: items
    };
  },
  components: {
    Item
  }
};
</script>
